import Main from '@views/main/Main.vue'

/**
 * meta除了原生参数外可配置的参数:
 * meta: {
 *  title: { String|Number|Function }
 *         显示在侧边栏、面包屑和标签栏的文字
 *         使用'{{ 多语言字段 }}'形式结合多语言使用，例子看多语言的路由配置;
 *         可以传入一个回调函数，参数是当前路由对象，例子看动态路由和带参路由
 *  hideInBread: (false) 设为true后此级路由将不会出现在面包屑中
 *  hideInMenu: (false) 设为true后在左侧菜单不会显示该页面选项
 *  notCache: (false) 设为true后页面在切换标签后不会缓存，如果需要缓存，无需设置这个字段，而且需要设置页面组件name属性和路由配置的name一致
 *  access: (null) 可访问该页面的权限数组，当前路由设置的权限会影响子路由
 *  icon: (-) 该页面在左侧菜单、面包屑和标签导航处显示的图标，如果是自定义图标，需要在图标名称前加下划线'_'
 *  beforeCloseName: (-) 设置该字段，则在关闭当前tab页时会去'@/router/before-close.js'里寻找该字段名对应的方法，作为关闭前的钩子函数
 * }
 */
const routers = [
  {
    path: '/',
    name: '_home',
    redirect: '/Home',
    component: Main,
    meta: {
      hideInMenu: false,
      notCache: true
    },
    children: [
      {
        path: '/Home',
        name: 'home',
        meta: {
          hideInMenu: false,
          title: '概览',
          notCache: true,
          icon: 'md-home'
        },
        component: () => import('@views/base/Home.vue')
      }
    ]
  }, {
    path: '/Login',
    name: 'login',
    meta: {
      title: 'Login - 登录',
      hideInMenu: true
    },
    component: () => import('@views/base/Login.vue')
  }, {
    path: '/ErrorLogger',
    name: 'errorLogger',
    meta: {
      hideInBread: true,
      hideInMenu: true
    },
    component: Main,
    children: [
      {
        path: '/ErrorLoggerPage',
        name: 'errorLoggerPage',
        meta: {
          icon: 'ios-bug',
          title: '错误收集'
        },
        component: () => import('@views/logger/Logger.vue')
      }
    ]
  }, {
    path: '/PlatManage',
    name: 'platManage',
    meta: {
      hideInBread: false,
      hideInMenu: false
    },
    component: Main,
    children: [
      {
        path: '/PlatManagePage',
        name: 'PlatManagePage',
        meta: {
          title: '平台管理',
          icon: 'md-apps'
        },
        component: () => import('@views/plat/PlatManage.vue')
      }
    ]
  }, {
    path: '/UserManage',
    name: 'userManage',
    meta: {
      hideInBread: false,
      hideInMenu: false
    },
    component: Main,
    children: [
      {
        path: '/UserManagePage',
        name: 'userManagePage',
        meta: {
          title: '用户管理',
          icon: 'md-person'
        },
        component: () => import('@views/user/UserManage.vue')
      }
    ]
  }, {
    path: '/UserRole',
    name: 'userRole',
    meta: {
      hideInBread: false,
      hideInMenu: false
    },
    component: Main,
    children: [
      {
        path: '/UserRoleManage',
        name: 'userRoleManage',
        meta: {
          title: '用户权限管理',
          icon: 'md-people'
        },
        component: () => import('@views/user-role/UserRole.vue')
      }
    ]
  }, {
    path: '/RoleManage',
    name: 'roleManage',
    meta: {
      hideInBread: false,
      hideInMenu: false
    },
    component: Main,
    children: [
      {
        path: '/RoleManagePage',
        name: 'roleManagePage',
        meta: {
          title: '权限管理',
          icon: 'md-list'
        },
        component: () => import('@views/role/RoleManage.vue')
      }
    ]
  }, {
    path: '/MenuManage',
    name: 'menuManage',
    meta: {
      hideInBread: false,
      hideInMenu: false
    },
    component: Main,
    children: [
      {
        path: '/MenuManagePage',
        name: 'menuManagePage',
        meta: {
          title: '菜单管理',
          icon: 'md-menu'
        },
        component: () => import('@views/menu/MenuManage.vue')
      }
    ]
  }
]

export default routers
